import { render, staticRenderFns } from "./CoursesSlider.vue?vue&type=template&id=2209ce22&scoped=true&"
import script from "./CoursesSlider.vue?vue&type=script&lang=ts&"
export * from "./CoursesSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesSlider.vue?vue&type=style&index=0&id=2209ce22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209ce22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSkeletonLoader})
